import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { LoaderComponent } from "../../../general/components/loader/loader.component";
import { GlassPillDirective } from "../../../general/directives/glass-pill.directive";
import { PropertyService } from "../../../../features/property/services/property.service";
import { PropertyStats } from "../../../../features/property/models/property.model";

@Component({
  selector: 'app-property-stats',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    LoaderComponent,
    GlassPillDirective
  ],
  templateUrl: './property-stats.component.html',
  styleUrl: './property-stats.component.scss',
})
export class PropertyStatsComponent implements OnInit {
    private cdr = inject(ChangeDetectorRef);
    private propertyService = inject(PropertyService);

    stats?: PropertyStats;

    ngOnInit(): void {
        this.propertyService.getPropertyStats().subscribe(stats => {
            this.stats = stats;
            this.cdr.detectChanges();
        });
    }
}